import { alpha as MuiAlpha } from '@mui/material';

export const alpha = (color: string, value: number) => MuiAlpha(color, value);
